module.exports = __webpack_public_path__ + "img/010.9d5e08dc.png";